import React from 'react';

import CoursePauseModal from './CoursePauseModal';
import styles from './CoursePauseToBeResumedPage.module.scss';
import ToBeResumedTable from './ToBeResumedTable';

function CoursePauseToBeResumedPage() {
  return (
    <div className={styles.root}>
      <CoursePauseModal />
      <ToBeResumedTable />
    </div>
  );
}

export default CoursePauseToBeResumedPage;
